import { Inject, Injectable, InjectionToken } from '@angular/core';

export const LOCAL_STORAGE = new InjectionToken<Storage>('Local Storage', {
  providedIn: 'root',
  factory: () => localStorage,
});

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  constructor(@Inject(LOCAL_STORAGE) public storage: Storage) {}

  // List of local storage keys
  redirectURL = 'REDIRECT_URL';
  linkRouterRedirect = 'LINK_ROUTER_REDIRECT';
  dawnWelcomeBack = 'DAWN_WELCOME_BACK';
  isAutobahnFlowKey = 'IS_AUTOBAHN_FLOW';

  getItem(key: string): string {
    return this.storage.getItem(key);
  }

  setItem(key: string, value: string): void {
    this.storage.setItem(key, value);
  }

  removeItem(key: string): void {
    this.storage.removeItem(key);
  }

  clear(): void {
    this.storage.clear();
  }

  // Methods for Autobahn flow flag
  setAutobahnFlow(): void {
    this.setItem(this.isAutobahnFlowKey, 'true');
  }

  isAutobahnFlow(): boolean {
    return this.getItem(this.isAutobahnFlowKey) === 'true';
  }

  clearAutobahnFlow(): void {
    this.removeItem(this.isAutobahnFlowKey);
  }
}
